import { render } from "./ModalPaynowInstruction.vue?vue&type=template&id=094a7cfc&scoped=true"
import script from "./ModalPaynowInstruction.vue?vue&type=script&lang=js"
export * from "./ModalPaynowInstruction.vue?vue&type=script&lang=js"

import "./ModalPaynowInstruction.vue?vue&type=style&index=0&id=094a7cfc&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-094a7cfc"]])

export default __exports__